import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import { NomenclatureContext } from "src/shared/lib/hooks/context/getNomenclatureContext";
import { Nomenclature } from "src/enitities/Table/";
import { saveRow, removeRow, addRow } from "src/shared";
import { API, apiRequests } from "src/shared/api/api";
import { useLocation, useSearchParams } from "react-router-dom";
import { Space, message } from "antd";
import { AddNomenclatureButton } from "src/widgets/Button";
import FilterNomenclature from "src/shared/ui/Tables/FilterNomenclature";

export default function TableNomenclature() {
  const [messageApi, contextHolder] = message.useMessage();
  const [searchParams, setSearchParams] = useSearchParams();
  const { token, websocket, initialData, nomenclatureDataCount } =
    useContext(NomenclatureContext);

  const { pathname } = useLocation();
  const [dataSource, setDataSource] = useState(initialData || []);
  const [total, setTotal] = useState(nomenclatureDataCount);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);

  const queryOffsetData = useCallback(
    (page, pageSize, name, filters = {}) => {
      // Собираем все параметры из searchParams и filters
      const params = {
        token: token,
        offset: page * pageSize - pageSize,
        limit: pageSize,
      };

      // Добавляем имя, если указано
      if (name) {
        params.name = name;
      }

      // Добавляем фильтры из searchParams
      searchParams.forEach((value, key) => {
        if (key !== "token" && key !== "limit" && key !== "offset" && key !== "page") {
          // Преобразуем строковые значения в нужные типы
          if (key === "category" || key === "global_category_id" || key === "chatting_percent") {
            params[key] = Number(value);
          } else if (key === "has_photos") {
            // has_photos - параметр для фильтрации товаров только с фото
            const hasPhotosValue = value === "true" || value === true;
            params[key] = hasPhotosValue;
            // Автоматически включаем фото в ответ, когда фильтруем по фото
            if (hasPhotosValue) {
              params["with_photos"] = true;
            }
          } else if (key === "with_photos") {
            // with_photos - параметр для включения фото в ответ
            params[key] = value === "true" || value === true;
          } else {
            params[key] = value;
          }
        }
      });

      // Добавляем фильтры из параметра filters (если передан)
      Object.keys(filters).forEach((key) => {
        if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
          params[key] = filters[key];
        }
      });

      setSearchParams({
        token,
        ...params,
      });

      apiRequests.nomenclature
        .getItems(params)
        .then((res) => {
          setDataSource(res.data.result);
          setTotal(res.data.count);
          setPage(page);
          setPageSize(pageSize);
          return res.data;
        });
    },
    // eslint-disable-next-line
    [token, searchParams]
  );


  // Функция для загрузки данных из searchParams (как getData в Prices)
  const loadDataFromParams = useCallback(async () => {
    const params = {
      token: token,
      offset: 0,
      limit: 10,
    };

    // Добавляем имя, если указано
    const nameFromParams = searchParams.get("name");
    if (nameFromParams) {
      params.name = nameFromParams;
    }

    // Добавляем фильтры из searchParams
    searchParams.forEach((value, key) => {
      if (key !== "token" && key !== "limit" && key !== "offset" && key !== "page" && key !== "name") {
        // Преобразуем строковые значения в нужные типы
        if (key === "category" || key === "global_category_id" || key === "chatting_percent") {
          params[key] = Number(value);
        } else if (key === "has_photos") {
          // has_photos - параметр для фильтрации товаров только с фото
          const hasPhotosValue = value === "true" || value === true;
          params[key] = hasPhotosValue;
          // Автоматически включаем фото в ответ, когда фильтруем по фото
          if (hasPhotosValue) {
            params["with_photos"] = true;
          }
        } else if (key === "with_photos") {
          // with_photos - параметр для включения фото в ответ
          params[key] = value === "true" || value === true;
        } else {
          params[key] = value;
        }
      }
    });

    try {
      const res = await apiRequests.nomenclature.getItems(params);
      setDataSource(res.data.result);
      setTotal(res.data.count);
      setPage(1);
      setPageSize(10);
    } catch (err) {
      console.error("Ошибка загрузки данных:", err);
    }
  }, [token, searchParams]);

  // Отслеживание изменений searchParams для фильтров (как в Prices)
  useEffect(() => {
    loadDataFromParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);


  const handleSaveImage = useCallback(
    (picture) => {
      if (!picture || !picture.entity_id) return;
      const newData = JSON.parse(JSON.stringify(dataSource));
      const index = dataSource.findIndex(
        (item) => item.id === picture.entity_id
      );
      // Проверяем, что элемент найден
      if (index === -1 || !newData[index]) return;
      
      // Инициализируем pictures если его нет
      if (!newData[index].pictures) {
        newData[index].pictures = [];
      }
      
      // Проверяем, есть ли уже такое фото
      const dubData = newData[index].pictures.filter(
        (item) => item.id === picture.id
      );
      if (dubData.length === 0) {
        newData[index].pictures.push(picture);
      }
      setDataSource(newData);
    },
    [dataSource]
  );

  const handleDeleteImage = async (id) => {
    const newData = dataSource.map((item) => {
      const newItem = JSON.parse(JSON.stringify(item));
      // const index = newItem.pictures.findIndex((item) => item.id === id);
      // if (index !== -1) {
      //   newItem.pictures.splice(index, 1);
      // }
      return newItem;
    });
    setDataSource(newData);
  };

  // // TODO: GO TO FOLDER OF MODEL;
  // const queryPictures = useCallback(async () => {
  //   const url = [];
  //   const request = [];
  //   for (let item of dataSource) {
  //     url.push(
  //       `https://${process.env.REACT_APP_APP_URL}/api/v1/pictures/?token=${token}&entity=nomenclature&entity_id=${item.id}`
  //     );
  //   }
  //   request.push(...url.map((url) => axios.get(url)));
  //   const newData = await axios.all(request).then((response) => {
  //     const bubble = dataSource.map((data) => {
  //       const newData = JSON.parse(JSON.stringify(data));
  //       const item = response.filter(
  //         (item) => item?.data[0]?.entity_id === data.id
  //       );
  //       newData.pictures = item[0]?.data || [];
  //       return newData;
  //     });
  //     return bubble;
  //   });
  //   return newData;
  // }, [dataSource, token]);

  // const picturesData = async () => {
  //   const newData = await queryPictures();
  //   setDataSource(newData);
  // };

  // useLayoutEffect(() => {
  //   // picturesData();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [token]);

  useEffect(() => {
    websocket.onmessage = (message) => {
      const data = JSON.parse(message.data);
      if (data.target === "nomenclature") {
        if (data.action === "create") {
          // сразу перезапрашиваем первую страницу
          addRow(dataSource, data.result, setDataSource);
        }
        if (data.action === "edit") {
          saveRow(dataSource, data.result, setDataSource);
        }
        if (data.action === "delete") {
          removeRow(dataSource, data.result.id, setDataSource);
        }
      }
      if (data.target === "pictures") {
        if (data.action === "create") {
          handleSaveImage(data.result);
        }
        if (data.action === "delete") {
          handleDeleteImage(data.result.id);
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, dataSource]);


  return (
    <>
      {contextHolder}
      <Space direction="vertical" style={{ width: "100%", marginBottom: 15 }}>
        <Space>
          <AddNomenclatureButton />
        </Space>
        <FilterNomenclature />
      </Space>
      {useMemo(
        () => {
          return (
            <Nomenclature
              page={page}
              dataSource={dataSource}
              handleSave={API.crud.edit(token, pathname, messageApi)}
              handleRemove={API.crud.remove(token, pathname, messageApi)}
              handleSaveImage={handleSaveImage}
              handleDeleteImage={API.pictures.removeImage(token, messageApi)}
              queryOffsetData={queryOffsetData}
              total={total}
              pageSize={pageSize}
              name={searchParams.get("name")}
              messageApi={messageApi}
            />
          );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
          dataSource,
          page,
          token,
          pathname,
          total,
          pageSize,
          handleSaveImage,
          queryOffsetData,
          messageApi,
        ]
      )}
    </>
  );
}
